module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "lawmap"
    }
  }, [_c('span', {
    staticClass: "my-position"
  }, [_vm._v("我的位置")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59935154"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/map.vue
// module id = 102
// module chunks = 1